import React from 'react'
import { GlobalData } from '@booking/index'

export const BookingExternalContext = React.createContext<GlobalData | null>(null)

export function useBookingExternal() {
  const ctx = React.useContext(BookingExternalContext)
  if (!ctx) throw new Error('useBookingExternal must be used inside BookingProvider')
  return ctx
}
